document.addEventListener('DOMContentLoaded', function () {
  // Custom gallery volume button: mute/unmute toggle
  document.body.addEventListener('click', function (e) {
    var volBtn = e.target.closest('[data-fr-volume-button]');
    if (volBtn) {
      var video = volBtn.parentElement.querySelector('video');
      if (video) {
        e.preventDefault();
        e.stopPropagation();
        video.muted = !video.muted;
        volBtn.classList.toggle('fr-volume-button--muted', video.muted);
        volBtn.classList.toggle('fr-volume-button--unmuted', !video.muted);
        volBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      }
      return;
    }
  });

  // Custom gallery play button: play/pause video on click
  document.body.addEventListener('click', function (e) {
    const playBtn = e.target.closest('[data-fr-play-button]');
    if (!playBtn) return;

    const video = playBtn.parentElement.querySelector('video');
    if (!video) return;

    const section = playBtn.closest('.custom-gallery-slideshow');
    if (!section) return;

    e.preventDefault();
    e.stopPropagation();

    if (video.paused) {
      // Pause all other videos in this gallery
      section.querySelectorAll('video').forEach(function (v) {
        if (v !== video) {
          v.pause();
          var btn = v.parentElement.querySelector('[data-fr-play-button]');
          if (btn) {
            btn.classList.remove('is-playing');
            btn.setAttribute('aria-label', 'Play video');
          }
        }
      });
      video.play();
      playBtn.classList.add('is-playing');
      playBtn.setAttribute('aria-label', 'Pause video');
    } else {
      video.pause();
      playBtn.classList.remove('is-playing');
      playBtn.setAttribute('aria-label', 'Play video');
    }
  });

  // When any video plays: hide its play button, pause all others in the same gallery
  document.body.addEventListener('play', function (e) {
    if (e.target.tagName !== 'VIDEO') return;
    var section = e.target.closest('.custom-gallery-slideshow');
    if (!section) return;
    // Hide play button for the video that is playing
    var playingBtn = e.target.parentElement.querySelector('[data-fr-play-button]');
    if (playingBtn) {
      playingBtn.classList.add('is-playing');
      playingBtn.setAttribute('aria-label', 'Pause video');
    }
    // Pause all other videos
    section.querySelectorAll('video').forEach(function (v) {
      if (v !== e.target && !v.paused) {
        v.pause();
        var btn = v.parentElement.querySelector('[data-fr-play-button]');
        if (btn) {
          btn.classList.remove('is-playing');
          btn.setAttribute('aria-label', 'Play video');
        }
      }
    });
  }, true);

  // On mobile: play video when its slide is active in the slider, pause when inactive
  (function setupMobileVideoActivePlay() {
    var isMobile = function () { return window.matchMedia('(max-width: 767px)').matches; };
    var sections = document.querySelectorAll('.custom-gallery-slideshow');
    sections.forEach(function (section) {
      var slides = section.querySelectorAll('.content-grid-item.swiper-slide');
      if (slides.length === 0) return;
      slides.forEach(function (slide) {
        var video = slide.querySelector('video');
        if (!video) return;
        var observer = new MutationObserver(function (mutations) {
          if (!isMobile()) return;
          mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              var isActive = slide.classList.contains('swiper-slide-active');
              if (isActive) {
                video.play().catch(function () {});
              } else {
                video.pause();
              }
            }
          });
        });
        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
        // Initial state: if already active on load, play
        if (isMobile() && slide.classList.contains('swiper-slide-active')) {
          video.play().catch(function () {});
        }
      });
    });
  })();

  // Show play button again when video ends or is paused
  document.body.addEventListener('ended', function (e) {
    if (e.target.tagName !== 'VIDEO') return;
    const playBtn = e.target.parentElement.querySelector('[data-fr-play-button]');
    if (playBtn) {
      playBtn.classList.remove('is-playing');
      playBtn.setAttribute('aria-label', 'Play video');
    }
  }, true);
  document.body.addEventListener('pause', function (e) {
    if (e.target.tagName !== 'VIDEO') return;
    const playBtn = e.target.parentElement.querySelector('[data-fr-play-button]');
    if (playBtn) {
      playBtn.classList.remove('is-playing');
      playBtn.setAttribute('aria-label', 'Play video');
    }
  }, true);

  // Update add-to-cart button when variant radio selection changes
  document.body.addEventListener('change', function (e) {
    const radio = e.target.closest('.variant-radio');
    if (!radio) return;

    const wrapper = radio.closest('.product-card-atc-wrapper');
    const atcBtn = wrapper && wrapper.querySelector('[data-custom-atc][data-variant-id]');
    if (atcBtn) {
      atcBtn.setAttribute('data-variant-id', radio.value);
    }
  });

  // Delegate add to cart actions
  document.body.addEventListener('click', function (e) {
    const atcBtn = e.target.closest('[data-custom-atc][data-variant-id]');
    if (!atcBtn) return;

    e.preventDefault();

    const variantId = atcBtn.getAttribute('data-variant-id');
    if (!variantId) {
      // Optionally alert or handle missing variant
      return;
    }
    atcBtn.disabled = true;
    const originalText = atcBtn.innerHTML;
    atcBtn.innerHTML = 'Adding...';

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(function (resp) {
      if (!resp.ok) throw new Error('Network error');
      return resp.json();
    })
    .then(function (data) {
      atcBtn.innerHTML = 'Added!';
      setTimeout(function () {
        atcBtn.innerHTML = originalText;
        atcBtn.disabled = false;
      }, 1200);

      document.dispatchEvent(new CustomEvent('custom-atc:added', { detail: data }));

      // Update cart count, rerender drawer, then open - all via promises
      var pageContainer = document.getElementById('PageContainer');
      var languageParam = (!pageContainer || !pageContainer.dataset.languageUrl || pageContainer.dataset.languageUrl === '/') ? '' : pageContainer.dataset.languageUrl;
      var sectionsUrl = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root + '?sections=cart-drawer' : '/?sections=cart-drawer';

      Promise.all([
        fetch(languageParam + '/cart?view=compare').then(function (r) { return r.json(); }),
        fetch(sectionsUrl).then(function (r) { return r.json(); })
      ])
        .then(function (results) {
          var cart = results[0];
          var sections = results[1];

          // Update cart count
          if (window.wetheme && window.wetheme.updateCartCount) {
            window.wetheme.updateCartCount(cart);
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('wetheme-cart-update', { detail: { cart: cart } }));
          }

          // Rerender cart drawer
          if (window.eventBus && sections && sections['cart-drawer']) {
            window.eventBus.emit('update:cart:drawer', { sections: sections });
          }

          // Open cart once updates are done
          if (window.eventBus) {
            window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
          }
        })
        .catch(function () {});
    })
    .catch(function (error) {
      atcBtn.disabled = false;
      atcBtn.innerHTML = originalText;
      // Optionally show error message
      alert('Something went wrong adding to cart.');
      console.error(error);
    });
  });
});